
<i18n>
{
  "en": {
    "description":
"<b>Synapbook is one of the powerful knowledge management tool for creating cloud-based notes in tree form</b> such as Evernote, OneNote, Google Keep and Workflowy. It has a number of other improved and different features from other tools.<br>Arrange your knowledge with Synapbook"
  },
  "kr": {
    "description":
"<b>Synapbook</b>은 Evernote, OneNote, Google Keep, Workflowy와 같은<br><b>클라우드 기반의 메모를 트리형태로 작성할수 있는 강력한 지식관리 도구 중 하나입니다.</b><br>다른 툴과는 여러가지 향상된 다른 차별점을 가지고 있습니다. 시냅북과 함께 지식을 정리하세요.",

    "Organize your notes structurally like mind map.": "노트를 마인드맵 같이 구조적으로 정리하세요.",

    "Memo or note, whatever you need": "용도에 맞게 원하는대로",

    "Features": "기능소개",
    "Fast cloud synchronization": "빠른클라우드 동기화",
    "Record easily with your mobile phone and access it powerfully with your PC": "PC핸드폰으로 간편하게 기록하고 피씨로 강력하게 관리하세요.",
    "Most of functions are available with various shortcut keys": "대부분의  기능을 다양한 방식의 단축키 시스템으로 이용할 수 있습니다.",
    "All shortcut keys can be customized": "모든 단축키 사용자 설정 가능",
    "The same settings are applied everywhere": "변경한 설정은 어디에서나 동일하게 적용",
    "The memo can be used even if network disconnected.": "통신이 단절되어도, 서버가 점검중이더라도 메모를 사용할 수 있습니다.",
    "Share notes with other users and collaborate extensively(soon)": "다른 유저와 노트 공유 및 강력한 협업 작업(soon)",
    "All data is stored locally, providing a very fast search and a pleasant editing experience.": "모든 데이터는 로컬로 저장되어 매우 빠른 검색과 쾌적한 편집환경을 제공합니다.",
    "All lines can be tagged separately, and line tags will lead you to a new document world.": "모든 라인은 별도의 태그를 부여할 수 있으며 라인 태그는 당신을 새로운 문서의 세계로 인도합니다.",

    "Checkboxes available as hotkeys, underline text color size radius, divider, etc.": "단축키로 이용 가능한 체크박스, 밑줄 글자색 크기반경, 구분선 등",
    "All revisions are stored on the server for a period of time and can be verified and recovered.": "수정내역은 모두 서버에 일정기간 저장되며 확인 및 복구가 가능합니다.",
    "Insert image": "이미지 삽입",
    "Notification settings": "알림 설정",
    "Show line-by-line modification times and modifiers": "라인별 수정 시간 및 수정자 표시"
  }
}
</i18n>

<template>
  <div class="hello">
    <div class="marginSection">
      <b-container sg="*"  class=left>
        <b-row>
          <b-col>
            <br>
        <p v-html="$t('description')"></p>

          </b-col>
        </b-row>
      </b-container>
    </div>
    <iframe width="560" height="315" src="https://www.youtube.com/embed/xFhdAHnhn8I?rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>

    <div class="marginSection">
      <h1>{{ $t('Organize your notes structurally like mind map.') }}</h1>
      <table>
        <tr>
          <td><img src="/static/imgs/product/table01_01.png"></td>
          <td><img src="/static/imgs/product/table01_02.png"></td>
          <td><img src="/static/imgs/product/table01_03.png"></td>
        </tr>
      </table>
    </div>

    <div class="marginSection">
      <h1>{{$t('Memo or note, whatever you need')}}</h1>
      <table>
      <tr>
          <td colspan=3><img src="/static/imgs/product/table02_01.png" style="width: 500px; height: auto"></td>
          <td class=bottom colspan=2><img src="/static/imgs/product/table02_04.png"></td>
        </tr>
        <tr>
          <td>
          <td class="top right"><img src="/static/imgs/product/table02_03.png"></td>
          <td colspan=3><img src="/static/imgs/product/table02_02.png" style="width: 500px; height: auto"></td>
        </tr>
      </table>
    </div>

    <div class="marginSection">
      <h2>{{$t("Features")}}</h2><br>
      <b-container mg="*"  class=left>
        <b-row class="margin20">
          <b-col cols="1"><img class="fullfill" src="/static/imgs/product/table03_01.png"></b-col>
          <b-col cols="5">
            <b>"{{$t('Fast cloud synchronization')}}"</b><br>
            {{$t("Record easily with your mobile phone and access it powerfully with your PC")}}<br>
            - Windows, Android, Linux(soon), Mac(soon)
          </b-col>
          <b-col cols="1"><img class="fullfill" src="/static/imgs/product/table03_06.png"></b-col>
          <b-col cols="5">
            <b>"{{$t("Powerful keyboard shortcut supporting.")}}"</b><br>
            {{$t("Most of functions are available with various shortcut keys")}}<br>
            - {{$t("All shortcut keys can be customized")}}<br>
            - {{$t("The same settings are applied everywhere")}}
          </b-col>
        </b-row>
        <b-row class="margin20">
          <b-col cols="1"><img class="fullfill" src="/static/imgs/product/table03_02.png"></b-col>
          <b-col cols="5">
            <b>"{{$t("Under offline mode")}}"</b><br>
            {{$t("The memo can be used even if network disconnected.")}}
          </b-col>
          <b-col cols="1"><img class="fullfill" src="/static/imgs/product/table03_05.png"></b-col>
          <b-col cols="5">
            <b>"{{$t("Collaboration")}}"</b><br>
            {{$t("Share notes with other users and collaborate extensively(soon)")}}
          </b-col>
        </b-row>
        <b-row class="margin20">
          <b-col cols="1"><img class="fullfill" src="/static/imgs/product/table03_03.png"></b-col>
          <b-col cols="5">
            <b>"{{$t("Fast access perfomance")}}"</b><br>
            {{$t("All data is stored locally, providing a very fast search and a pleasant editing experience.")}}
          </b-col>
          <b-col cols="1"><img class="fullfill" src="/static/imgs/product/table03_04.png"></b-col>
          <b-col cols="5">
            <b>"{{$t("Powerful line attribute")}}"</b><br>
            {{$t("All lines can be tagged separately, and line tags will lead you to a new document world.")}}
          </b-col>
        </b-row>
      </b-container>
    </div>

    <b-container mg="*" class="left margin60" style="margin-top: 30px; font-size: 18px;">
      <div class="margin5">- {{$t("Checkboxes available as hotkeys, underline text color size radius, divider, etc.")}}</div>
      <div class="margin5">- {{$t("All revisions are stored on the server for a period of time and can be verified and recovered.")}}</div>
      <div class="margin5">- {{$t("Insert image")}}(soon)</div>
      <div class="margin5">- {{$t("Notification settings")}}</div>
      <div class="margin5">- {{$t("Show line-by-line modification times and modifiers")}}</div>
    </b-container>

    <div class="">
      <ul>
        <li><a href="" target="_blank">Powered by Inertry</a></li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'product',
  data () {
    return {
      locale: 'kr',
      msg: 'Make powerful knowdge'
    }
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.fullfill {
   width: 100%;
}

.marginSection { margin-bottom: 60px; }
.margin20 { margin-bottom: 20px; }

.margin5 { margin-bottom: 5px; }

.row.no-gutter {
  margin-left: 0;
  margin-right: 0;
}
.left {
  text-align: left;
}
.bottom {
  vertical-align: bottom;
}
.top {
  vertical-align: top;
}
.right {
  text-align: right;
}
table {
  margin-left: auto;
  margin-right: auto;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
td {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Product.vue